module.exports = __webpack_public_path__ + "img/3d10530.jpg";